import download from 'downloadjs';
import * as XLSX from 'xlsx';

import { getBotCallHistory } from '@/services/api/bots';
import { simplifyConversations } from '@/utils/api/elastic/elastic-fromatting-fns';
import { displayErrorSnackbar } from '@/utils/display-error-snackbar';
import { downloadWorkbookXlsx } from '@/utils/export/download-workbook-xlsx';

export const downloadConversationHistory = async ({
    botId,
    idsAndPermissions,
    filterModelToQuery,
    sortModel,
    enqueueSnackbar,
    downloadJson,
    isChat,
}: {
    botId: string;
    idsAndPermissions: any;
    filterModelToQuery: any;
    sortModel: any;
    enqueueSnackbar: any;
    downloadJson: boolean;
    isChat: boolean;
}) => {
    try {
        const allHistory = await getBotCallHistory(
            idsAndPermissions,
            { page: 0, pageSize: 10000 },
            filterModelToQuery,
            sortModel,
        );

        const simplified = simplifyConversations(allHistory, isChat);

        const maxFlowItems = Math.max(
            ...simplified.map(
                (conv: { flowItems: string | any[] }) =>
                    conv.flowItems?.length || 0,
            ),
            0, // Add default value of 0 in case the array is empty
        );

        const flowHeaders = Array.from(
            { length: maxFlowItems },
            (_, i) => `flow_${i + 1}`,
        );

        let headers = [
            'sessionId',
            ...(isChat ? [] : ['phoneNumber']),
            'testUser',
            'turnCount',
            'startedAt',
            'duration',
            'stickers',
            'duration (in sec)',
        ];

        if (!isChat) {
            headers.push('endReason');
            headers.push('phoneNumber');
        }

        headers.push(...flowHeaders);

        const excelData = simplified.map((row: any) => {
            const excelRow = { ...row };

            const flowItems = row.flowItems || [];
            excelRow.stickers = row.stickers.join(', ');

            flowItems.forEach((item: string, index: number) => {
                excelRow[`flow_${index + 1}`] = item;
            });

            return excelRow;
        });

        if (downloadJson) {
            const jsonOutput = JSON.stringify(simplified, null, 2);
            const jsonBlob = new Blob([jsonOutput], {
                type: 'application/json',
            });
            download(
                jsonBlob,
                `${botId}_conversation_history.json`,
                'application/json',
            );
        } else {
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(excelData, {
                header: headers,
            });
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Conversations');
            downloadWorkbookXlsx({
                workbook,
                filename: `${botId}_conversation_history.xlsx`,
            });
        }

        enqueueSnackbar('Conversation history downloaded successfully', {
            variant: 'success',
        });

        return { success: true };
    } catch (e) {
        displayErrorSnackbar(
            e,
            enqueueSnackbar,
            `download_simplified_bot_${botId}`,
        );
        return { success: false, error: e };
    }
};
